import VirtualizedGridItem from "@/components/common/virtualized/virtualized-grid-item";
import VoiceCard, {
  VoiceCardProps,
} from "@/components/pages/home/components/voices/voice-card";
import VoiceCardPlaceholder from "@/components/pages/home/components/voices/voice-card-placeholder";

const VirtualizedVoiceCard = (props: VoiceCardProps) => {
  const placeholder = <VoiceCardPlaceholder />;
  const component = <VoiceCard {...props} />;

  return (
    <VirtualizedGridItem placeholder={placeholder} component={component} />
  );
};

export default VirtualizedVoiceCard;
